import '.d{display:flex;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.g6{min-height:100vh;}.ssr-plugin'
import '.dj{background:var(--palette-white);}.ssr-plugin'
import '.ab{max-width:77.5rem;}.ssr-plugin'
import '.g7{align-self:center;}.ssr-plugin'
import '.bc{flex-shrink:0;}.ssr-plugin'
import '.g8{padding-block:1rem;}.ssr-plugin'
import '.fe{gap:0.75rem;}.ssr-plugin'
import '.g9{height:3rem;}.ssr-plugin'
import '.ae{justify-content:space-between;}.ssr-plugin'
import '.t{align-items:center;}.ssr-plugin'
import '.ah{flex-wrap:wrap;}.ssr-plugin'
import '.ga{height:0.25rem;}.ssr-plugin'
import '.n{width:100%;}.ssr-plugin'
import '.gb{border-radius:999px;}.ssr-plugin'
import '.gc{background:var(--gray-200);}.ssr-plugin'
import '.bg{height:100%;}.ssr-plugin'
import '.cl{background:var(--brand-primary);}.ssr-plugin'
import '.gd{transition:width 0.3s ease;}.ssr-plugin'
import '.bd{flex:1;}.ssr-plugin'
import '.ct{min-height:0px;}.ssr-plugin'
import '.r{align-items:stretch;}.ssr-plugin'
import '.ge{padding-bottom:1.5rem;}.ssr-plugin'
import { ReactNode, useEffect } from 'react'
import { styled } from 'inlines'
import { Property } from 'csstype'
import useMediaQuery from '@app/util/useMediaQuery'
import { Title } from '@app/components/core/typography/Title'
import { CloseButton } from '@app/components/core/button/CloseButton'
import { pages } from '@app/util/links'
import { useLocation } from 'wouter'
import { ClientOnly, useAuthState } from '@based/sdk/react'

export const InitiativeCreatePageLayout = ({
  title,
  gap = '1rem',
  children,
  onClose,
  progress,
}: {
  title: string
  gap?: Property.Gap<(string & {}) | 0>
  children: ReactNode
  onClose: VoidFunction
  progress?: { current: number; total: number }
}) => {
  const isMobile = useMediaQuery()

  const authState = useAuthState()
  const [_location, navigate] = useLocation()
  const isAuthed = authState && authState.userId

  useEffect(() => {
    if (!isAuthed) {
      navigate(pages.home)
    }
  }, [isAuthed, navigate])

  return (
    <ClientOnly>
      <div className="d e g6 dj"
      >
        <div className="ab g7 bc"
          style={{
            width: isMobile ? '100%' : '85%',
            paddingInline: isMobile ? '5rem' : 0,}}
        >
          <nav className="g8 d e fe"
          >
            <div className="g9 d ae t ah"
            >
              <Title.H5>{title}</Title.H5>
              <CloseButton onClick={onClose} />
            </div>
            {progress && progress.total > 0 && (
              <div className="ga n gb gc"
              >
                <div className="bg gb cl gd"
                  style={{
                    width: `${(progress.current / progress.total) * 100}%`,}}
                />
              </div>
            )}
          </nav>
        </div>
        <div className="bd ct d e r ge ab g7"
          style={{
            gap: gap,
            width: isMobile ? '100%' : '85%',
            paddingInline: isMobile ? '5rem' : 0,}}
        >
          {children}
        </div>
      </div>
    </ClientOnly>
  )
}
